import { render, staticRenderFns } from "./ApplyProject.vue?vue&type=template&id=bdd203ca&scoped=true"
import script from "./ApplyProject.vue?vue&type=script&lang=js"
export * from "./ApplyProject.vue?vue&type=script&lang=js"
import style0 from "./ApplyProject.vue?vue&type=style&index=0&id=bdd203ca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd203ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdd203ca')) {
      api.createRecord('bdd203ca', component.options)
    } else {
      api.reload('bdd203ca', component.options)
    }
    module.hot.accept("./ApplyProject.vue?vue&type=template&id=bdd203ca&scoped=true", function () {
      api.rerender('bdd203ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/children/ApplyProject.vue"
export default component.exports